export default __webpack_public_path__ + "static/media/robot_portrait_sad.bb1474e0.svg";